import type { RouteObject } from 'react-router';
import { lazyComponent } from '@/platform/lazyComponent';
import { Require } from '@/platform/Require';

const TrainingOverviewPage = lazyComponent(() => import('./TrainingOverviewPage').then((m) => m.TrainingOverviewPage));
const TrainingFormPage = lazyComponent(() => import('./TrainingFormPage').then((m) => m.TrainingFormPage));
const TrainingSessionPage = lazyComponent(() => import('./TrainingSessionPage').then((m) => m.TrainingSessionPage));
const AthleteTrainingTab = lazyComponent(() => import('./AthleteTrainingTab').then((m) => m.AthleteTrainingTab));

export const trainingRoutes: RouteObject[] = [
  { path: 'training', element: <Require permission="training.view"><TrainingOverviewPage /></Require> },
  { path: 'training/new', element: <Require permission="training.create"><TrainingFormPage /></Require> },
  { path: 'training/sessions/:id', element: <Require permission="training.view"><TrainingSessionPage /></Require> },
];
export const athleteTrainingRoutes: RouteObject[] = [{ path: 'training', element: <Require permission="training.view"><AthleteTrainingTab /></Require> }];
